import { inject, observer } from 'mobx-react'
import { css } from '@emotion/react'
import { Refresh } from '../../../../assets/icons'
import toastr from 'toastr'

// Clickable link to refresh their Plaid account linked with non-GC account
const PlaidRefresh = props => {
  const { store, accountId, className, onSuccess } = props

  const refreshPlaidLink = async () => {
    const result = await store.refreshPlaidAccount(accountId)
    if (result?.loginNeeded) {
      toastr.error('Please update your credentials.')
    }

    if (typeof onSuccess === 'function') {
      onSuccess()
    }
  }

  // Financial institution credentials invalidated

  return (
    <button className={className} onClick={refreshPlaidLink}>
      <Refresh
        css={css`
          margin: 0 6px 0 0;
        `}
      />
      Refresh
    </button>
  )
}

export default inject('store')(observer(PlaidRefresh))
